import styled from 'styled-components';

export const FormContainer = styled.div`
  padding: 20px 30px;
  position: relative;
  background: ${({ theme }) => theme.white.a10};
`;

export const DelContainer = styled.div`
  position: absolute;
  left: 30px;
  bottom: 20px;
`;

export const OptionItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  padding: 12px;
  background-color: ${({ theme }) => theme.white.a10};
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
  font-size: 1.333rem;
  letter-spacing: 0.3px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a10};
  align-items: center;
`;

export const Caret = styled.div`
  padding-right: 10px;
  color: ${({ theme }) => theme.baseBlue.a6};
  svg {
    stroke-width: 1.5px !important;
  }
`;
